import { t } from '@lingui/core/macro';
import { PROPERTY_GROUPS } from './constants';
export const getMetadataPropertyGroups = (properties) => {
    const generalInformation = properties.filter((property) => PROPERTY_GROUPS.GENERAL_INFORMATION.includes(property.name));
    const lifecycleAndStatus = properties.filter((property) => PROPERTY_GROUPS.LIFECYCLE_AND_STATUS.includes(property.name));
    const dates = properties.filter((property) => PROPERTY_GROUPS.DATES.includes(property.name));
    const commercial = properties.filter((property) => PROPERTY_GROUPS.COMMERCIAL.includes(property.name));
    const renewalAndTermination = properties.filter((property) => PROPERTY_GROUPS.RENEWAL_AND_TERMINATION.includes(property.name));
    const liabilityAndRisk = properties.filter((property) => PROPERTY_GROUPS.LIABILITY_AND_RISK.includes(property.name));
    const hr = properties.filter((property) => PROPERTY_GROUPS.HR.includes(property.name));
    const regulatory = properties.filter((property) => PROPERTY_GROUPS.REGULATORY.includes(property.name));
    const clausesAndTerms = [
        {
            id: 'commercial',
            type: 'label',
            label: t({
                message: 'Commercial',
                comment: 'Bulk action: Metadata - Commercial group label',
            }),
            children: commercial,
        },
        {
            id: 'renewal-and-termination',
            type: 'label',
            label: t({
                message: 'Renewal and termination',
                comment: 'Bulk action: Metadata - Renewal and termination group label',
            }),
            children: renewalAndTermination,
        },
        {
            id: 'liability-and-risk',
            type: 'label',
            label: t({
                message: 'Liability and risk',
                comment: 'Bulk action: Metadata - Liability and risk group label',
            }),
            children: liabilityAndRisk,
        },
        {
            id: 'hr',
            type: 'label',
            label: t({
                message: 'HR',
                comment: 'Bulk action: Metadata - HR group label',
            }),
            children: hr,
        },
        {
            id: 'regulatory',
            type: 'label',
            label: t({
                message: 'Regulatory',
                comment: 'Bulk action: Metadata - Regulatory group label',
            }),
            children: regulatory,
        },
    ];
    return [
        {
            id: 'general-information',
            label: t({
                message: 'General information',
                comment: 'Bulk action: Metadata - General information group label',
            }),
            group: {
                type: 'nested',
                children: generalInformation,
            },
        },
        {
            id: 'lifecycle-and-status',
            label: t({
                message: 'Lifecycle and status',
                comment: 'Bulk action: Metadata - Lifecycle and status group label',
            }),
            group: {
                type: 'nested',
                children: lifecycleAndStatus,
            },
        },
        {
            id: 'dates',
            label: t({
                message: 'Dates',
                comment: 'Bulk action: Metadata - Dates group label',
            }),
            group: {
                type: 'nested',
                children: dates,
            },
        },
        {
            id: 'clauses-and-terms',
            label: t({
                message: 'Clauses and terms',
                comment: 'Bulk action: Metadata - Clauses and terms group label',
            }),
            group: {
                type: 'label',
                children: clausesAndTerms,
            },
        },
    ];
};
